import { Box, Modal } from "@xcorejs/ui";
import { useCallback, useRef, useState } from "react";

interface HappyHoursModalProps {
  content: string;
}

export const HappyHoursModal = ({ content }: HappyHoursModalProps) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  const handleLoad = useCallback(() => {
    ref.current?.contentWindow?.document?.body?.scrollHeight && setContentHeight(ref.current.contentWindow.document.body.scrollHeight);
  }, []);

  return (
    <Modal size="lg" padding="4rem" _close={{ zIndex: 5 }}>
      <Box minHeight="70vh" position="relative" width="100%" alignItems="center" height={contentHeight}>
        <iframe ref={ref} onLoad={handleLoad} srcDoc={content} width="100%" frameBorder={0} height="100%" />
      </Box>
    </Modal>
  );
};
